import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Flex, Icon, Container, Text, Box } from 'roo-ui/components';
import { useDataLayer } from 'hooks/useDataLayer';
import { navigationDestinations } from 'components/Header/HeaderDesktop/NavigationLinks/Destinations/destinations';
import { DestinationPageLink, DestinationsMenuWrapper, DestinationColumn, TitleLink, TextTitle } from './primitives';
import AppLink from 'components/AppLink';

const LinkWrapper = ({ destinationName, children }) => {
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Site Navigation', value: `${destinationName} Destination Selected` });
  }, [emitInteractionEvent, destinationName]);

  return <Box onClick={handleOnClick}>{children}</Box>;
};

LinkWrapper.propTypes = {
  destinationName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const DestinationsMenu = React.memo(() => {
  return (
    <Container>
      <DestinationsMenuWrapper>
        {navigationDestinations.map((destinations, index) => {
          const { name, path, children } = destinations;
          const isLink = !!path;

          return (
            <DestinationColumn key={index}>
              {isLink && (
                <LinkWrapper destinationName={name}>
                  <TitleLink as={AppLink} to={path} data-testid="title-with-link">
                    <Text fontSize="base" mr={3}>
                      {name}
                    </Text>
                    <Icon name="chevronRight" color="greys.steel" size={16} />
                  </TitleLink>
                </LinkWrapper>
              )}
              {!isLink && <TextTitle data-testid="text-only-title">{name}</TextTitle>}
              <Flex flexDirection="column" data-testid="destinations-sub-lists">
                {children.map((child) => (
                  <LinkWrapper destinationName={child.name} key={child.name}>
                    <DestinationPageLink as={AppLink} to={child.path} mt={2}>
                      {child.name}
                    </DestinationPageLink>
                  </LinkWrapper>
                ))}
              </Flex>
            </DestinationColumn>
          );
        })}
      </DestinationsMenuWrapper>
    </Container>
  );
});

DestinationsMenu.displayName = 'DestinationsMenu';

export default DestinationsMenu;
